import { ManageAgent } from './ManageAgent';
import { ManageAgentProps } from './ManageAgent';
import { AgentActionsProvider } from './contexts/AgentActionsContext';
import { TransientSelectedActionsProvider } from './contexts/TransientSelectedActionsContext';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';

const BaseManageAgentProvider = (props: ManageAgentProps) => {
  return (
    <AgentActionsProvider>
      <TransientSelectedActionsProvider>
        <ManageAgent {...props} />
      </TransientSelectedActionsProvider>
    </AgentActionsProvider>
  );
};

export const ManageAgentProvider = withIntegrationApp(BaseManageAgentProvider);
